import { useState, useEffect, useCallback, useRef } from 'react';
import Axios from 'axios';
import LoadingModal from '../../Layout/LoadingModal.js';
import { FaTrash } from 'react-icons/fa';
import { VscOpenPreview } from 'react-icons/vsc';
import { useAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert';
import Button from 'react-bootstrap/Button';
import dayjs from 'dayjs';

const rowTitles = ['Código Balanza', 'Fecha', 'Válido por (días)', 'Vista Previa', 'Eliminar'];

let CancelToken = Axios.CancelToken;
let source = CancelToken.source();

const IntVerFixedScalesPending = ({ openPreviewModal }) => {

  const alert = useAlert();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const isFirstRender = useRef(true);

  const GetData = useCallback(() => {

    setLoading(true);

    if (source) {
      source.cancel();
      source = CancelToken.source();
    }

    const opts = { cancelToken: source.token };
    const url = '/api/intVer/fixedScales/pending';

    Axios.get(url, opts)
    .then((res) => {
      setLoading(false);
      if (res.data?.length) {
        const sortedData = res.data.sort((a, b) => ((a.code.localeCompare(b.code, 'es', {numeric: true})) || (a.date.localeCompare(b.date, 'es', {numeric: true}))));
        setData(sortedData);
      }
      
    })
    .catch((err) => {
      setLoading(false);
      if (Axios.isCancel(err)) {
        alert.show('Petición cancelada', {type: 'info'});
      } else if (!err.response) {
        console.log('Petición cancelada');
      } else if (err.response.status === 500) {
        alert.show('No se recibió respuesta del servidor', {type: 'error'})
      } else {
        alert.show(err.response.data.msg, {type: 'error'})
      }
    });
  }, [alert]);

  const DeleteRecordStepOne = (idx) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="modal-delete-confirm-container">
            <h4>Está eliminando una verificación intermedia</h4>
            <p> {'¿Está seguro(a) de eliminar la verificación '}{<b>{data[idx].code + ' - ' + dayjs(data[idx].date.split('T')[0]).tz('America/Santiago').format('DD/MM/YYYY')}</b>}{'?'} </p>
            <div className="d-flex mt-3">
              <Button className="flex-1 silver-black me-2" onClick={() => onClose()}> No, deseo salir </Button>
              <Button className="flex-1 lb-white" onClick={() => { onClose(); DeleteRecordStepTwo(idx) }}> Si, deseo eliminar </Button>
            </div>
          </div>
        );
      }
    })
  }

  const DeleteRecordStepTwo = (idx) => {
    setLoading(true);

    if (source) {
      source.cancel();
      source = CancelToken.source();
    }

    const opts = { cancelToken: source.token };
    const url = '/api/intVer/fixedScales/delete';

    Axios.post(url, { code: data[idx].code, date: data[idx].date }, opts)
    .then((res) => {
      setLoading(false);
      alert.show(res.data.msg, {type: 'success', timeout: 10000});
      GetData();
    })
    .catch((err) => {
      setLoading(false);
      if (Axios.isCancel(err)) {
        alert.show('Petición cancelada', {type: 'info'});
      } else if (!err.response) {
        console.log('Petición cancelada');
      } else if (err.response.status === 500) {
        alert.show('No se recibió respuesta del servidor', {type: 'error'})
      } else {
        alert.show(err.response.data.msg, {type: 'error'})
      }
    });
  }

  useEffect(() => {
    if (isFirstRender.current) {
      GetData();
    }
  }, [GetData]);

  useEffect(() => { isFirstRender.current = false }, []);

  return (
    <>
      <LoadingModal loading={loading}/>
      <div className="modal-table-outer-container">
        <div className="modal-table-row-inner-container">
          <div className="modal-table-sticky-header-container">
            <div className="modal-table-sticky-header">
              { rowTitles.map((item, itemIdx) => <div key={itemIdx} className="modal-table-row-container"> {item} </div> )}
            </div>
          </div>
          {data.length ?
            data.map((item, itemIdx) => {
              return (
                <div key={itemIdx} className="modal-table-row-input-container">
                  <div className="modal-table-row-container">
                    <span className="modal-table-title"> {item.code} </span>
                  </div>
                  <div className="modal-table-row-container">
                    <span className="modal-table-title"> {item.date ? dayjs(item.date.split('T')[0]).tz('America/Santiago').format('DD/MM/YYYY') : '-'} </span>
                  </div>
                  <div className="modal-table-row-container">
                    <span className="modal-table-title"> {item.validDays || '-'} </span>
                  </div>
                  <div className="modal-table-row-container">
                    <Button 
                      className="d-flex p-1 rounded-circle bg-lb-white" 
                      disabled={loading} 
                      title="Vista Previa" 
                      onClick={() => openPreviewModal([{ code: item.code, date: item.date }], 1 )}
                    >
                      <VscOpenPreview color="white" className="icon-style"/>
                    </Button>
                  </div>
                  <div className="modal-table-row-container">
                    <Button className="d-flex p-1 rounded-circle bg-lb-white" disabled={loading} title="Eliminar" onClick={() => DeleteRecordStepOne(itemIdx)}>
                      <FaTrash color="white" className="icon-style"/>
                    </Button>
                  </div>
                </div>
              )
            })
          :
            <span className="modal-table-loading-text"> No hay información para mostrar </span>
          }
        </div>
      </div>
    </>
  )
}

export default IntVerFixedScalesPending;